var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DialogEventEnum } from 'app/ui/dialog/dialog-event.enum';
import { ApplicationsService } from '../applications.service';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { UserSettingsService } from 'app/user/user-settings.service';
import { camelCase } from 'app/core/case-transform';
import { mergeMap } from 'rxjs/operators';
import { validate } from 'app/user/form.functions';
import { settings } from 'app/core/settings';
var CreateApplicationDcComponent = /** @class */ (function () {
    function CreateApplicationDcComponent(applicationsService, dialogService, userSettingsService) {
        this.applicationsService = applicationsService;
        this.dialogService = dialogService;
        this.userSettingsService = userSettingsService;
        this.creationModel = {
            tenant: '',
            login: '',
            password: '',
            name: null,
            nameChanged: false,
            projectsIsLoaded: false,
            projects: [],
            selectedProject: null
        };
        this.iApplicationName = 1;
        this.permissionsErrorMessage = "The specified account doesn't have required permissions<br/> in the tenant.\n  <a href=\"https://abbyy.cloud/media/1133/abbyy_fc_cloud_rest_api_getstarted_10.pdf\" target=\"_blank\">Learn more</a>";
        this.isLoading = false;
    }
    Object.defineProperty(CreateApplicationDcComponent.prototype, "settings", {
        get: function () {
            return settings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateApplicationDcComponent.prototype, "urlCloud", {
        get: function () {
            return this.settings.сloudSite.protocol + "://" + this.settings.сloudSite.name;
        },
        enumerable: true,
        configurable: true
    });
    CreateApplicationDcComponent.prototype.getProjects = function () {
        var _this = this;
        this.isLoading = true;
        this.applicationsService
            .getProjects(this.creationModel.tenant, this.creationModel.login, this.creationModel.password)
            .subscribe(function (items) {
            if (!items) {
                _this.error = 'Error';
                _this.errorDescription = _this.permissionsErrorMessage;
            }
            else {
                _this.creationModel.projects = items;
                _this.creationModel.projectsIsLoaded = true;
            }
            _this.isLoading = false;
        }, function (error) { return _this._onError(error); });
    };
    CreateApplicationDcComponent.prototype.validate = function (form) {
        validate(form);
    };
    CreateApplicationDcComponent.prototype.submitForm = function (form) {
        this.validate(form);
        if (this.creationModel.projectsIsLoaded) {
            this._create(form);
        }
        else {
            this._nextStage(form);
        }
    };
    CreateApplicationDcComponent.prototype.cancel = function () {
        this.dialogService.close();
    };
    CreateApplicationDcComponent.prototype.onHideError = function () {
        this.error = null;
    };
    CreateApplicationDcComponent.prototype._nextStage = function (form) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.creationModel.projectsIsLoaded = false;
                        if (form.invalid) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getProjects()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this._onError(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CreateApplicationDcComponent.prototype._create = function (form) {
        return __awaiter(this, void 0, void 0, function () {
            var binding, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        binding = {
                            id: null,
                            tenant: this.creationModel.tenant,
                            project: this.creationModel.selectedProject,
                            user: this.creationModel.login,
                            password: this.creationModel.password
                        };
                        if (form.invalid) {
                            return [2 /*return*/];
                        }
                        this.isLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.applicationsService
                                .createApplication(this.creationModel.name, this.userSettingsService.serviceType)
                                .pipe(mergeMap(function (application) {
                                binding.id = application.id;
                                return _this.applicationsService.bindingApplication(binding);
                            }))
                                .subscribe(function () {
                                _this.isLoading = false;
                                _this.dialogService.close(DialogEventEnum.save);
                            }, function (error) { return _this._onError(error); })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this._onError(error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CreateApplicationDcComponent.prototype.changeProject = function (nameProject) {
        this.iApplicationName = 2;
        this.setNewNameApplication(nameProject);
        this.onHideError();
    };
    CreateApplicationDcComponent.prototype.changeName = function (nameProject) {
        if (!nameProject) {
            this.creationModel.nameChanged = false;
        }
        else {
            this.creationModel.nameChanged = true;
        }
        this.onHideError();
    };
    CreateApplicationDcComponent.prototype.setNewNameApplication = function (name) {
        var nameApplication = name + "_" + this.iApplicationName;
        if (!this.creationModel.nameChanged) {
            if (this.applicationsService.searchByName(name).length === 0) {
                this.creationModel.name = name;
            }
            else if (this.applicationsService.searchByName(nameApplication).length === 0) {
                this.creationModel.name = nameApplication;
            }
            else {
                this.iApplicationName++;
                this.setNewNameApplication(name);
            }
        }
    };
    CreateApplicationDcComponent.prototype._onError = function (response) {
        if (response.status === 400) {
            var responseJson = response.json();
            this.error = camelCase(responseJson.error);
            this.errorDescription = this._getErrorDescription(responseJson);
        }
        this.isLoading = false;
    };
    CreateApplicationDcComponent.prototype._getErrorDescription = function (responseJson) {
        var modelState = responseJson.modelState;
        if (!modelState) {
            if (responseJson.errorDescription.indexOf('User does not have required role') === 0) {
                return this.permissionsErrorMessage;
            }
            return responseJson.errorDescription;
        }
        return Object.keys(modelState)
            .map(function (fieldName) { return modelState[fieldName].join('\n'); })
            .join('\n');
    };
    return CreateApplicationDcComponent;
}());
export { CreateApplicationDcComponent };
